import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { ElMessage } from 'element-plus';
import { computed, ref, watch } from 'vue';
export default {
  name: 'SelectCategoryModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, null],
      defualt: null
    },
    categoryList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const categoryTable = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, newVal => {
      if (!newVal) {
        categoryTable.value.clearRadioRow();
      }
    });

    function confirm() {
      const selectRow = categoryTable.value.getRadioRecord();

      if (!selectRow) {
        ElMessage.error('请勾选分类后再进行操作!');
        return;
      }

      emit('success', selectRow.merTypeId);
    }

    return (_ctx, _cache) => {
      const _component_vxe_column = _resolveComponent("vxe-column");

      const _component_vxe_table = _resolveComponent("vxe-table");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择分类",
        width: "600px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "50vh"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_table, {
            align: "center",
            data: __props.categoryList,
            ref_key: "categoryTable",
            ref: categoryTable
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_column, {
              type: "radio",
              width: "60"
            }), _createVNode(_component_vxe_column, {
              field: "typeName",
              title: "名称"
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};